import { call, put } from 'redux-saga/effects';
import { updateDomainUser } from '../../../../state/analytic/analyticAdminSlice';
import bugsnagClient from '../../../../services/bugsnag/bugsnag';
import { backendClient } from '../../../../services/api/backend-client';

export function* updateDomainUserSaga(action) {
    const { uid, ...payload } = action.payload || {};
    try {
        const { data } = yield call(
            [backendClient, backendClient.patch],
            `admin/users/${encodeURIComponent(uid)}`,
            payload
        );
        yield put(updateDomainUser(data));
    } catch (err) {
        bugsnagClient.notify(err);
        console.error('Failed to update domain user', err?.response?.status, err?.message);
    }
}